import React from 'react';
import { StyledAiButton, StyledButtonText } from './styles';

interface AIButtonProps {
  id: string;
  buttonText: string;
  onClick: () => void;
  disabled: boolean;
  state: string;
  iconPosition?: 'left' | 'right';
  className?: string;
}

export const AIButton: React.FC<AIButtonProps> = ({
  id,
  buttonText,
  onClick,
  disabled,
  iconPosition = 'left',
  className,
  state,
}) => (
  <StyledAiButton
    id={id}
    onClick={onClick}
    disabled={disabled}
    className={className}
    state={state}
    icon={null}
    iconPosition={iconPosition}
  >
    <StyledButtonText>
      {buttonText}
    </StyledButtonText>
  </StyledAiButton>
);
